<template>
  <i class="icon" :class="[icon, sizeRenamed]"></i>
</template>

<script lang="ts">
export default {
  name: "MGIcon",
  props: {
    icon: {
      type: String || Object,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
  },
  computed: {
    sizeRenamed() {
      if (this.size.length > 0) return `size-${this.size}`;
      else return null;
    },
  },
};
</script>
